import sharedConfig from '../sharedConfig';

export const ZRM_DEV_BRAND = 'dev_brand';
export const HOST_APP = 'hostApp';
export const ZRM_API = 'ZRM_API';
export const PANDA_THEME = 'ZRM_panda-theme';

// FEATURE_FLAGS
export const ZRM_RENT_GUARANTEE_ENABLED = 'ZRM_RENT_GUARANTEE_ENABLED';
export const ZRM_USE_FREEMIUM_TEST_DATA = 'ZRM_USE_FREEMIUM_TEST_DATA';
export const ZRM_ONBOARDING_WIZARD_ENABLED = 'ZRM_ONBOARDING_WIZARD_ENABLED';
export const ZRM_NEW_ONBOARDING_WIZARD_ENABLED = 'ZRM_NEW_ONBOARDING_WIZARD_ENABLED';
export const ZRM_USE_UPLIFT_BRAIN_TEST_DATA = 'ZRM_USE_UPLIFT_BRAIN_TEST_DATA';
export const ZRM_MARKETING_COMPONENTS_ENABLED = 'ZRM_MARKETING_COMPONENTS_ENABLED';
export const ZRM_MULTIPLEX_GROUPS_ENABLED = 'ZRM_MULTIPLEX_GROUPS_ENABLED';
export const ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED = 'ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED';
export const ZRM_TOTAL_MONTHLY_PRICE_ENABLED = 'ZRM_TOTAL_MONTHLY_PRICE_ENABLED';
export const ZRM_AUTH_0_MFA_ENABLED = 'ZRM_AUTH_0_MFA_ENABLED';
export const ZRM_SPOTLIGHT_LISTING_ENABLED = 'ZRM_SPOTLIGHT_LISTING_ENABLED';
export const ZRM_MULTIPLEX_LISTING_FLOW_ENABLED = 'ZRM_MULTIPLEX_LISTING_FLOW_ENABLED';

// DEVTOOLS
export const ZRM_REACT_QUERY_DEVTOOLS = 'ZRM_REACT_QUERY_DEVTOOLS';
export const ZRM_REDUX_DEVTOOLS = 'ZRM_REDUX_DEVTOOLS';
export const ZRM_ENABLE_GA = 'ZRM_ENABLE_GA';
export const ZRM_DEVTOOLS_ENABLED = 'ZRM_DEVTOOLS_ENABLED';

export const ZRM_MOCK_USER_ENABLED = 'ZRM_MOCK_USER_ENABLED';
export const ZRM_MOCK_USER_EMAIL = 'ZRM_MOCK_USER_EMAIL';
export const ZRM_MOCK_USER_IMPERSONATOR_TOKEN = 'ZRM_MOCK_USER_IMPERSONATOR_TOKEN';
export const ZRM_MOCK_USER_IMPERSONATOR_EMAIL = 'ZRM_MOCK_USER_IMPERSONATOR_EMAIL';

export const ZRM_MOCK_USERS_GENERATE_NEW_EMAIL = 'xxxxxxxxxx@zillow.com';

export const ZRM_MOCK_USERS = [
  {
    email: ZRM_MOCK_USERS_GENERATE_NEW_EMAIL,
    comment: 'Generate a new user',
  },
  {
    email: 'mockeduser@zillow.com',
    comment: 'Default mock user',
  },
  {
    email: 'rocket_ship_user@zillow.com',
    comment: 'Single family feed listings',
  },
  {
    email: 'mfh_rocket_ship_user@zillow.com',
    comment: 'Multifamily feed listings',
  },
  {
    email: 'mfh_user@zillow.com',
    comment: 'Multifamily customer',
  },
  {
    email: 'company_admin@zillow.com',
    comment: 'Company admin for user management',
  },
  {
    email: 'nucleus_user@zillow.com',
    comment: 'Single family paid inclusion',
  },
  {
    email: 'single_family_legacy@zillow.com',
    comment: 'Old single family legacy user',
  },
  {
    email: 'flat_fee_rocket_ship_user@zillow.com',
    comment: 'Single family with flat fee product',
  },
  {
    email: 'rentalrevenueplatform@zillow.com',
    comment: 'To test multifamily packages',
  },
];

const FeatureFlagConstants = {
  // features
  [ZRM_RENT_GUARANTEE_ENABLED]: false,
  [ZRM_ONBOARDING_WIZARD_ENABLED]: false,
  [ZRM_MARKETING_COMPONENTS_ENABLED]: false,
  [ZRM_MULTIPLEX_GROUPS_ENABLED]: false,
  [ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED]: false,
  [ZRM_TOTAL_MONTHLY_PRICE_ENABLED]: false,
  [ZRM_AUTH_0_MFA_ENABLED]: false,
  [ZRM_SPOTLIGHT_LISTING_ENABLED]: false,
  [ZRM_MULTIPLEX_LISTING_FLOW_ENABLED]: false,
  [ZRM_NEW_ONBOARDING_WIZARD_ENABLED]: false,
  // DEVTOOLS
  [ZRM_USE_UPLIFT_BRAIN_TEST_DATA]: false,
  [ZRM_USE_FREEMIUM_TEST_DATA]: false,
  [ZRM_REACT_QUERY_DEVTOOLS]: false,
  [ZRM_REDUX_DEVTOOLS]: false,
  [ZRM_ENABLE_GA]: false,
  [ZRM_DEVTOOLS_ENABLED]: false,

  // mocked user is only auto enabled for the sherman environment
  [ZRM_MOCK_USER_ENABLED]: false,
  [ZRM_MOCK_USER_EMAIL]: '',
  [ZRM_MOCK_USER_IMPERSONATOR_TOKEN]: '',
  [ZRM_MOCK_USER_IMPERSONATOR_EMAIL]: '',

  // TODO: move those non-boolean values out since they're not
  // strictly features.
  [HOST_APP]: 'none',
  [ZRM_DEV_BRAND]: sharedConfig.defaultBrand,
  [ZRM_API]: sharedConfig.defaultZgApi,
  [PANDA_THEME]: 'legacy-zillow',
};

export default FeatureFlagConstants;
